import React from "react";
import ThemeTooltip from "../../modules/apps/components/UI/ThemeTooltip";

/**
 * Shows why a button is disabled. A disabled button never receives hover, so the
 * tooltip sits on a wrapper around it (the button also needs pe-none).
 */
export const withDisabledHint = (button: React.ReactElement, disabledReason?: string): React.ReactElement =>
    disabledReason
        ? <ThemeTooltip typeTooltip="default" placement="top" text={disabledReason} Wrapper={button} />
        : button;
